import React, { useEffect, useState } from 'react';
import { chamSocKhachHangApi } from '../../../api/chamSocKhachHangApi';
import { DefaultButton, PrimaryButton } from '../../../components/editor/button';
import { InValidMessage } from "../../../components/editor/invalid_message"
import { FormGroup, FormGroupInline } from "../../../components/form-group"
import { useForm } from 'react-hook-form';
import { Modal } from 'semantic-ui-react';
import { showNotify } from '../../../helpers/toast';
import { useCommonContext } from '../../../contexts/common';
import Switch from 'devextreme-react/switch';
import TextBox from 'devextreme-react/text-box';

const PhuHuynhCSKHDetailModal = ({ id, onCancel, onSuccess }) => {
    const [formData, setFormData] = useState({});
    const { register, trigger, errors } = useForm();
    const { translate } = useCommonContext();
    useEffect(() => {
        handleReload();
    }, [id])
    const handleReload = async () => {
        const res = await chamSocKhachHangApi.Detail(id);
        if (res.is_success) {
            setFormData(res.data);
        }
    }
    const handleSubmit = async () => {
        trigger().then(async (isValid) => {
            if (isValid) {
                const res = await chamSocKhachHangApi.Update(formData);
                if (res.is_success) {
                    showNotify({ text: "Cập nhật thành công", type: "success" })
                    onSuccess();
                } else {
                    showNotify({ text: "Cập nhật không thành công", type: "error" })
                }
            }
        })
    }
    return (
        <div>
            <Modal
                open={true}
                size="small"

                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    {id > 0 ? (
                        <p>{translate('Cập nhật')}</p>
                    ) : (
                        <p>{translate('Thêm mới')}</p>
                    )}
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <input className="hide" name="id" defaultValue={formData.id}></input>
                        <div className="row">
                            <div className="col-md-12">
                                <FormGroup label={"Nội dung"}>
                                    <TextBox
                                        stylingMode='outlined'
                                        value={formData.noi_dung}
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, noi_dung: e.value })
                                            }
                                        }}
                                    />
                                    <InValidMessage
                                        name="nam_hoc"
                                        defaultValue={formData.noi_dung}
                                        register={register({ required: true })}
                                        errors={errors}
                                        message={'Vui lòng điền nội dung'}
                                    />
                                </FormGroup>
                            </div>
                            {/* <div className="col-md-12">
                                <FormGroup label={"Ghi chú"}>
                                    <TextBox
                                        stylingMode='outlined'
                                        value={formData.ghi_chu}
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, ghi_chu: e.value })
                                            }
                                        }}
                                    />
                                </FormGroup>
                            </div> */}
                            <div className="col-md-12 padding-top-1rem">
                                <FormGroupInline label={"Đã xử lý"}>
                                    <Switch
                                        stylingMode='outlined'
                                        value={formData.da_xu_ly}
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, da_xu_ly: e.value })
                                            }
                                        }}
                                    />
                                </FormGroupInline>
                            </div>
                            <div className="col-md-12">
                                <FormGroup label={"Kết quả xử lý"}>
                                    <TextBox
                                        stylingMode='outlined'
                                        value={formData.ket_qua_xu_ly}
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, ket_qua_xu_ly: e.value })
                                            }
                                        }}
                                    />
                                </FormGroup>
                            </div>
                        </div>
                    </form>

                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text={"Đóng"} onClick={onCancel} />
                        <PrimaryButton text={id > 0 ? "Cập nhật" : "Thêm mới"} onClick={handleSubmit} />

                    </div>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default PhuHuynhCSKHDetailModal;